import { render, staticRenderFns } from "./verification-tabs.vue?vue&type=template&id=a4c94468"
import script from "./verification-tabs.vue?vue&type=script&lang=js"
export * from "./verification-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports